import { Card, Grid, Typography, Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import { getLeaveCount } from 'src/services/leaveService';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';
import { totalLeaveDetails } from 'src/models/leave';
import { AppActions } from 'src/store/AppReducer';
import {shouldHideNoPayFromApplySummary} from './leaveBalanceUtils';

const TotalLeaves = (props: {
  employeeId?: string;
  sendData?: boolean;
}) => {
  const dispatch = useDispatch();

  const textStyle = {
    fontSize: '12px',
    color: '#5B5B5B',
    fontWeight: 400,
    marginLeft: '5px'
  };

  const textWrap = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem'
  };

  const iconWrap = {
    display: 'flex',
    alignItems: 'center'
  };

  const iconStyle = {
    fontSize: 10,
    color: '#5569FF',
    transform: 'rotate(45deg)'
  };

  const appUser = useSelector((state: RootStateType) => state.appReducer.user);

  const [leaveBalance, setLeaveBalance] = useState<any>([]);
  const [leaveCount, setLeaveCount] = useState<totalLeaveDetails>();

  const availableLeave = (empId) => {
    dispatch(AppActions.showLoader());
    let responseData = [];
    getLeaveCount(empId)
      .then((res) => {
        if (res.data) {
          responseData = res.data.data;
          setLeaveBalance(responseData);
          calculateTotalLeave(responseData);
        }
        dispatch(AppActions.hideLoader());
      })
      .catch((e) => {
        dispatch(AppActions.hideLoader());
      });
  };

  const calculateTotalLeave = (leaveCount) => {
    let totalLeaveAvailable = 0;
    let totalLeaveTaken = 0;
    let totalMonthlyLeaveTaken = 0;
    let totalLeaveBalance = 0;

    leaveCount.forEach((item) => {
      if (item?.leaveType === 'No Pay Leave') return;
      totalLeaveAvailable += item.leavesAvailable ?? 0;
      totalLeaveTaken += item.leavesTaken ?? 0;
      totalMonthlyLeaveTaken += item.leavesTakenInThisMonth ?? 0;
      totalLeaveBalance += item.balance ?? 0;
    });

    setLeaveCount({
      totalLeaveAvailable: totalLeaveAvailable,
      totalLeaveTaken: totalLeaveTaken,
      totalMonthlyLeaveTaken: totalMonthlyLeaveTaken,
      totalLeaveBalance: totalLeaveBalance
    });
  };

  useEffect(() => {
    availableLeave(props?.employeeId ? props?.employeeId : appUser?.EmployeeId);
  }, [props?.sendData]);

  return (
    <>
      <Card style={{ padding: '1rem', minHeight: '30rem' }}>
        <Grid item>
          <Typography style={{ fontSize: '12px' }} variant="h3">
            Leave Summary
          </Typography>
          <Divider
            style={{ marginTop: '1rem', marginBottom: '1rem' }}
          ></Divider>
        </Grid>
        <Grid item>
          {leaveBalance
            ?.filter((item) => !shouldHideNoPayFromApplySummary(item))
            .map((item) => (
            <Grid style={textWrap} key={item.leaveType}>
              <Grid style={iconWrap}>
                <CropSquareIcon sx={iconStyle} />
                <Typography style={textStyle} fontWeight="light" variant="h5">
                  {item.leaveType}
                </Typography>
              </Grid>
              <Typography style={textStyle} fontWeight="light" variant="h5">
                {item.leaveType === 'No Pay Leave' ? (
                  <span style={{ color: '#5569FF' }}>
                    {item.leavesTaken ?? 0} / {item.leavesTaken ?? 0}
                  </span>
                ) : item.leavesAvailable > 0 ? (
                    <Grid>
                      <span style={{ color: '#5569FF' }}>
                        {item.leavesAvailable - item.leavesTaken}{' '}
                      </span>{' '}
                      <span>/ {item.leavesAvailable}</span>
                    </Grid>
                ) : item.leaveType === 'Lieu Leave' ? (
                  <>
                    <span style={{ color: '#5569FF' }}>0 </span>{' '}
                    <span>/ 0</span>
                  </>
                ) : (
                  <span style={{ color: '#000' }}>N/A</span>
                )}
              </Typography>
            </Grid>
          ))}
        </Grid>
        <Divider style={{ marginTop: '1rem', marginBottom: '1rem' }}></Divider>
        {
          <Grid item sx={{ marginLeft: '10px !important' }}>
            <Grid style={textWrap}>
              <Typography style={textStyle} fontWeight="light" variant="h5">
                Total Leave Taken
              </Typography>
              <Typography style={textStyle} fontWeight="light" variant="h5">
                <span style={{ color: '#5569FF' }}>
                  {leaveCount?.totalLeaveTaken}
                </span>{' '}
                / {leaveCount?.totalLeaveAvailable}
              </Typography>
            </Grid>
            <Grid style={textWrap}>
              <Typography style={textStyle} fontWeight="light" variant="h5">
                Leave In This Month
              </Typography>
              <Typography style={textStyle} fontWeight="light" variant="h5">
                <span style={{ color: 'red' }}>
                  {leaveCount?.totalMonthlyLeaveTaken}
                </span>{' '}
                / {leaveCount?.totalLeaveAvailable}
              </Typography>
            </Grid>
            <Grid style={textWrap} sx={{ marginBottom: '0 !important' }}>
              <Typography style={textStyle} fontWeight="light" variant="h5">
                Total Leave Available
              </Typography>
              <Typography style={textStyle} fontWeight="light" variant="h5">
                <span style={{ color: '#5569FF' }}>
                  {leaveCount?.totalLeaveBalance}
                </span>{' '}
                / {leaveCount?.totalLeaveAvailable}
              </Typography>
            </Grid>
          </Grid>
        }
      </Card>
    </>
  );
};

export default TotalLeaves;
